module.exports = __webpack_public_path__ + "static/media/Ellipse.21aa6bf4.svg";